import type { ReactElement } from 'react';

import { ActionTrigger } from '@crm/shared/ui';

import { useInWorkOrFinishDealMutation } from './api';

import type { TInWorkOrFinishDealInvalidationScope } from './model';
import type { TDeal } from '@crm/entities/deal';

interface InWorkOrFinishDealProps {
    dealIds: readonly TDeal['id'][];
    invalidationScope: TInWorkOrFinishDealInvalidationScope;
    onSuccess?: () => void;
    trigger: ReactElement;
}

export const InWorkOrFinishDeal = ({
    dealIds,
    invalidationScope,
    onSuccess,
    trigger,
}: InWorkOrFinishDealProps) => {
    const mutation = useInWorkOrFinishDealMutation({ invalidationScope });

    const handleClick = async () => {
        try {
            await mutation.mutateAsync({ dealIds });
            onSuccess?.();
        } catch {
            // Ошибка уже отображена через mutation.onError.
        }
    };

    return <ActionTrigger render={trigger} disabled={mutation.isPending} onClick={handleClick} />;
};
